<template>
  <div class="page trip-planner-page" v-if="!manifest.hideTripPlanner">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'TripPlanner' | lang }}</div>
    </header>
    <div v-if="isConnected">
      <!-- <div class="floating-label">
        <input placeholder=" " type="text" v-placegsearch="placeFrom" />
        <label>{{ 'From' | lang }}</label>
      </div> -->
      <!-- <div class="floating-label">
        <input placeholder=" " type="text" v-placegsearch="placeTo" />
        <label>{{ 'To' | lang }}</label>
      </div> -->
      <div class="trip-planner-form">
        <place-picker v-model="placeTo" :label="'Destination' | lang" />
        <place-picker v-model="placeFrom" :label="'Origin' | lang" :default-current-pos="true" />
        <div class="floating-label">
          <select v-model="tripType" placeholder=" " type="text">
            <option :value="null">{{ 'BestTrip' | lang }}</option>
            <option value="FEWER_TRANSFERS">{{ 'FewerTransfers' | lang }}</option>
            <option value="LESS_WALKING">{{ 'LessWalking' | lang }}</option>
          </select>
          <label>{{ 'TripPreference' | lang }}</label>
        </div>
        <div class="floating-label">
          <select v-model="hourType" placeholder=" " type="text">
            <option value="o">{{ 'OriginAtHour' | lang }}</option>
            <option value="d">{{ 'DestinationAtHour' | lang }}</option>
          </select>
          <label>{{ 'HourLimitPreference' | lang }}</label>
        </div>
        <div class="floating-label">
          <input v-model="date" placeholder=" " type="date" />
          <label>{{ 'Date' | lang }}</label>
        </div>
        <div class="floating-label">
          <input v-model="time" placeholder=" " type="time" />
          <label>{{ 'HourMinute' | lang }}</label>
        </div>

        <!-- <button v-if="section === 'search' || !isMobile" @click="compute" :disabled="!formIsValid">{{ 'ComputeTrip' | lang }}</button>
        <button v-else-if="section === 'map' && isMobile" @click="section = 'directions'">{{ 'Directions' | lang }}</button>
        <button v-else-if="section === 'directions' && isMobile" @click="section = 'map'">{{ 'Map' | lang }}</button> -->

      </div>
      <!-- <app-time-picker v-model="time" id="time-input" /> -->

      <!-- <ul>
        <li v-for="(route, idx) in routesFound" :key="idx">
          <div>{{ route.legs[0].duration.text }}</div>
          <div>{{ route.legs[0].time.text }}</div>

          <ul>
            <li v-for="(step, idx2) in route.legs[0].steps" :key="'s' + idx2"></li>
          </ul>
        </li>
      </ul> -->
      <div id="trips-found" :class="{ hide: section === 'search' }">
        <div id="directions-panel" :class="{ hide: section !== 'directions' }"></div>
        <div id="map" :class="{ hide: section !== 'map' }"></div>
      </div>

    </div>

    <div v-else class="flexcentered bigger">{{ 'ConnectionRequired' | lang }}</div>

    <footer class="flexrow">
      <!-- <button v-if="routesResult.status" @click="routesResult.status = false">{{ 'EditTrip' | lang }}</button> -->
      <button v-if="section === 'search' || !isMobile" @click="compute" :disabled="!formIsValid">{{ 'ComputeTrip' | lang }}</button>
      <button v-else-if="section === 'map' && isMobile" @click="section = 'directions'">{{ 'Directions' | lang }}</button>
      <button v-else-if="section === 'directions' && isMobile" @click="section = 'map'">{{ 'Map' | lang }}</button>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import PlacePicker from '@/components/PlacePicker.vue'
import moment from 'moment'

export default {
  name: 'TripPlannerPage',
  mixins: [ page ],
  components: { PlacePicker },
  data () {
    return {
      placeFrom: null, // { place_id: "ChIJ41sgIFiUgUcRofM12thDs60", description: 'Desenzano (precompilato)' },
      placeTo: null, // { place_id: "ChIJ75ly6DWZeEcRjPSBAl_5Peo", description: 'Levico (precompilato)' },
      hourType: 'o',
      tripType: null, // 'FEWER_TRANSFERS',
      date: moment().add(5, 'minute').format('YYYY-MM-DD'),
      time: moment().add(5, 'minute').format('HH:mm'),
      routesFound: [],
      routesResult: {
        status: false,
        errorMessage: null
      },
      section: 'search' // mobile-only
    }
  },
  computed: {
    formIsValid () {
      return !!(this.placeFrom && this.placeTo && this.time && this.hourType)
    }
  },
  methods: {
    preBack () {
      if (this.isMobile) {
        if (this.section === 'map') {
          this.section = 'directions'
          return false
        } else if (this.section === 'directions') {
          this.section = 'search'
          return false
        }
      }
      return true
    },
    async compute () {

      if (this.placeFrom.is_cp || this.placeTo.is_cp) {
        try {
          let result = await this.getCurrentPosition()
          console.log(result)
          let place = { latlng: { lat: result.coords.latitude, lng: result.coords.longitude }, description: this.dictValue('CurrentPosition') }
          if (this.placeFrom.is_cp) this.placeFrom = place
          if (this.placeTo.is_cp) this.placeTo = place
        } catch (result) {
          if (result.code === 0) {
            this.setRouteError('CurrentLocationErrorGeneric')
            return
          } else if (result.code === 1) {
            this.setRouteError('CurrentLocationErrorPermissionDenied')
            return
          } else if (result.code === 2) {
            this.setRouteError('CurrentLocationErrorUnavailable')
            return
          } else if (result.code === 3) {
            this.setRouteError('CurrentLocationErrorTimeout')
            return
          }
        }
      }

      let timeDateObj = moment(this.date + ' ' + this.time, 'YYYY-MM-DD HH:mm').toDate()
      let isPast = moment().diff(timeDateObj) > 0
      if (isPast) {
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('PastDateTime'),
          key: 'tripplanner'
        })
        return
      }
      // console.log(timeDateObj)
      var modes = ['BUS', 'RAIL', 'SUBWAY', 'TRAIN', 'TRAM']
      let departureTime = this.hourType === 'o' ? timeDateObj : null
      let arrivalTime = this.hourType === 'o' ? null : timeDateObj
      var request = {
        origin: this.placeFrom.place_id ? { placeId: this.placeFrom.place_id } : this.placeFrom.latlng,
        destination: this.placeTo.place_id ? { placeId: this.placeTo.place_id } : this.placeTo.latlng,
        travelMode: window.google.maps.DirectionsTravelMode.TRANSIT,
        provideRouteAlternatives: true,
        transitOptions: {
          departureTime,
          arrivalTime,
          // routingPreference: routing,
          modes,
          routingPreference: this.tripType // 'FEWER_TRANSFERS' // alternative: LESS_WALKING
        }
      }
      if (JSON.stringify(this.lastRequestCompleted) === JSON.stringify(request)) {
        if (this.routesFound.status) {
          this.section = 'directions'
        }
        return
      }
      this.directionsRenderer.setMap(null)
      this.directionsRenderer.setPanel(null)
      new window.google.maps.DirectionsService().route(request, (result, status) => {
        this.lastRequestCompleted = request
        console.log(result, status, status == window.google.maps.DirectionsStatus.OK)
        if (status == window.google.maps.DirectionsStatus.OK) {
          this.routesFound = result
          this.routesResult.status = true
          this.routesResult.errorMessage = null
          this.ensureGMapsInitialized()
          this.directionsRenderer.setDirections(result)
          this.section = 'directions'
        } else if (status == window.google.maps.DirectionsStatus.NOT_FOUND) {
          // indicates at least one of the locations specified in the request's origin, destination, or waypoints could not be geocoded
        } else if (status == window.google.maps.DirectionsStatus.ZERO_RESULTS) {
          //  indicates no route could be found between the origin and destination
          this.setRouteError('ZeroResults')
        } else if (status == window.google.maps.DirectionsStatus.MAX_WAYPOINTS_EXCEEDED) {
          // indicates that too many DirectionsWaypoint fields were provided in the DirectionsRequest
        } else if (status == window.google.maps.DirectionsStatus.MAX_ROUTE_LENGTH_EXCEEDED) {
          // indicates the requested route is too long and cannot be processed. This error occurs when more complex directions are returned. Try reducing the number of waypoints, turns, or instructions
        } else if (status == window.google.maps.DirectionsStatus.INVALID_REQUEST) {
          //  indicates that the provided DirectionsRequest was invalid. The most common causes of this error code are requests that are missing either an origin or destination, or a transit request that includes waypoints
        } else if (status == window.google.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
          //  indicates the webpage has sent too many requests within the allowed time period
        } else if (status == window.google.maps.DirectionsStatus.REQUEST_DENIED) {
          // indicates the webpage is not allowed to use the directions service
        } else if (status == window.google.maps.DirectionsStatus.UNKNOWN_ERROR) {
          // indicates a directions request could not be processed due to a server error. The request may succeed if you try again
        }
      })
    },
    async ensureGMapsInitialized () {
      const directionsRenderer = new window.google.maps.DirectionsRenderer()
      const directionsService = new window.google.maps.DirectionsService()
      let center = this.manifest.mapCenter
      if (!this.manifest.mapCenter) {
        try {
          let result = await this.getCurrentPosition()
          center = { lat: result.coords.latitude, lng: result.coords.longitude }
        } catch {
          // nada
        }
      }
      center = center || { lat: 0, lng: 0 }
      const map = new window.google.maps.Map(this.$el.querySelector("#map"), {
        zoom: center.zoom || 9,
        center: center
      })
      console.log('center', center)
      directionsRenderer.setMap(map)
      directionsRenderer.setPanel(this.$el.querySelector("#directions-panel"))
      this.directionsRenderer = directionsRenderer
      this.directionsService = directionsService
      let directionsPanel = this.$el.querySelector('#directions-panel')

      this.directionsRenderer.setMap(map)
      this.directionsRenderer.setPanel(directionsPanel)
    },
    setRouteError (errorKey) {
      this.internalBus.$emit('notify:error', {
        text: this.dictValue(errorKey || 'errorOccured'), // this.dictValue('errorOccured'),
        key: this.notifierKey
      })
      this.routesFound = []
      this.routesResult.status = false
      this.routesResult.errorMessage = errorKey
    }
  },
  beforeDestroy () {},
  mounted () {
    this.placeFrom = { is_cp: true, description: this.dictValue('CurrentPosition') }
    setTimeout(() => {
      this.ensureGMapsInitialized()
    }, 1000) // TODO: edit me!
  },
  watch: {}
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

#map button {
  min-width: 0;
  min-height: 0;
}

#app.mobile .trip-planner-form {
  grid-template-columns: repeat(1, 100%);
}

#app.desktop.small .trip-planner-form {
  grid-template-columns: repeat(2, 50%);
}

.trip-planner-form {
  display: grid;
  column-gap: .1rem;
  grid-template-columns: repeat(4, 25%);
  padding-top: .1rem;
  // overflow: auto;
  max-height: 100%;
}

#app.mobile .trip-planner-page {
  #trips-found {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    transform: translate(0, 0);
    transition: all .3s ease;
    will-change: transform, opacity;
    overflow: hidden;

    &.hide {
      opacity: 0;
      transform: translate(0, 3rem);
      pointer-events: none;
    }

    #directions-panel {
      padding: $pagePadding;
      background: var(--white);
    }
    #directions-panel, #map {
      margin: 0;
      max-width: 100%;
      opacity: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: auto;

      &.hide {
        opacity: 0;
        transform: translate(0, 3rem);
        pointer-events: none;
      }
    }
  }
}

.trip-planner-page {

  #trips-found {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    overflow: hidden;
    flex: 1 1 auto;

    #map {
      flex: 1 1 auto;
      // height: 100%;
    }

    #directions-panel {
      max-width: 30%;
      margin-right: 1rem;
    }
  }

  // #directions-panel {}
}

</style>
